import React from 'react';
import { Alert } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import useTranslation from 'utils/hooks/useTranslation';

import styles from './style.module.scss';

const EdenredBanner = () => {
  const { translateText } = useTranslation();

  return (
    <Alert
      data-testid="edenredRetirementBanner"
      className={styles.edenredBanner}
      type="warning"
      showIcon
      icon={<WarningOutlined />}
      message={
        <span>
          <strong>{translateText('corporateAccounts.wallet.edenredBanner.title')}</strong>{' '}
          {translateText('corporateAccounts.wallet.edenredBanner.description')}
        </span>
      }
    />
  );
};

export default EdenredBanner;
